import React from "react";
import Proptypes from "prop-types";

interface IRobotSetSelectorProps {
  onSetChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const RobotSetSelector: React.FC<IRobotSetSelectorProps> = ({
  onSetChange,
}): React.ReactElement => (
  <select
    aria-label="Select robot set"
    name="robotset"
    className="pa3 h-25 ba white bg-dark-gray border-dark-gray"
    onChange={onSetChange}
  >
    <option value="set1">Set1</option>
    <option value="set2">Set2</option>
    <option value="set3">Set3</option>
    <option value="set4">Set4</option>
  </select>
);

RobotSetSelector.propTypes = {
  onSetChange: Proptypes.func.isRequired,
};

export default RobotSetSelector;
